import React from 'react';
import urlBase from '../url-base';
import axios from 'axios';

class ConfirmCompany extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      success: null,
      wasConfirmed: false
    };

    this.styles = {

    };
  }


  componentWillMount() {
    let dataSend = {
      id: window.location.href.split('cp=')[1]
    };

    if (dataSend.id == undefined || dataSend.id.length == 0) {
      alert('Link de confirmação incorreto');
    }
    else {
      axios.post(urlBase.loopBack + 'Companies/ConfirmCompany', dataSend)
      .then((result) => {
        if (result.data.wasConfirmed == true) {
          let state = this.state;
          state.loading = false;
          state.success = null;
          state.wasConfirmed = true;
          this.setState(state);
        }
        else {
          let dataConfirm = {
            id: dataSend.id,
            type: 'COMPANY'
          };

          axios.post(urlBase.loopBack + 'Companies/SendEmailOnActivation', dataConfirm)
          .then(() => {
            let state = this.state;
            state.loading = false;
            state.success = true;
            state.wasConfirmed = false;
            this.setState(state);
          })
          .catch(function (error) {
            alert(error);
          });
        }
      })
      .catch(function () {
        let state = this.state;
        state.loading = false;
        state.success = false;
        state.wasConfirmed = false;
        this.setState(state);
      }.bind(this));
    }
  }

  render() {
    return (
      <div>
        {
          this.state.loading == true ? (
        <div style={{textAlign: 'center',marginTop: 70,color: '#505050'}}>
          <p>
            Realizando a confirmação...
            <i
              style={{width: 16, marginLeft: 5 }}
              className="fa fa-spinner fa-spin">
              &nbsp;
            </i>
          </p>
        </div>
          ) : (
            this.state.success != null ? (
              this.state.success == true ? (
        <div style={{textAlign: 'center',marginTop: 70,color: '#505050'}}>
          <h1 style={{fontFamily: 'RubikBold',fontSize: 30}}>Adesão confirmada com sucesso.</h1>
         {/*  <p>Para acompanhar o andamento acesse <a href={urlBase.client+'proposalstatus'}>Situação da Proposta</a></p> */}
        </div>
            ) : (
        <div style={{textAlign: 'center',marginTop: 70,color: '#505050'}}>
          <p>Foi encontrado um problema ao confirmar a proposta.</p>
          <p>Por favor, tente novamente.</p>
        </div>
              )
            ) : (
              this.state.wasConfirmed == true ? (
        <div style={{textAlign: 'center',marginTop: 70,color: '#505050'}}>
          <h1 style={{fontFamily: 'RubikBold',fontSize: 30}}>Adesão já confirmada anteriormente.</h1>
        </div>
              ) : ('')
            )
          )
        }

      </div>
    );
  }
}

export default ConfirmCompany;



/** WEBPACK FOOTER **
 ** ./src/components/ConfirmCompany.js
 **/